import { render } from "./UserGuess.vue?vue&type=template&id=2371e8fd"
import script from "./UserGuess.vue?vue&type=script&lang=js"
export * from "./UserGuess.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__